import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, AlertCircleIcon, CheckCircleIcon, StarIcon } from 'lucide-react';
const performanceZones = [{
  zone: 'Zona Roșie',
  emoji: '🔴',
  level: 'Minim',
  threshold: '1.400 €',
  commission: '30%',
  description: 'Performanță sub target, risc de audit.',
  color: 'red',
  bgColor: 'from-red-50 to-red-100',
  borderColor: 'border-red-300',
  textColor: 'text-red-700',
  icon: AlertCircleIcon
}, {
  zone: 'Zona Portocalie',
  emoji: '🟠',
  level: 'În creștere',
  threshold: '2.450 €',
  commission: '40%',
  description: 'Nivel de recuperare – analiză și recomandări.',
  color: 'orange',
  bgColor: 'from-orange-50 to-orange-100',
  borderColor: 'border-orange-300',
  textColor: 'text-orange-700',
  icon: TrendingUpIcon
}, {
  zone: 'Zona Verde 1',
  emoji: '🟢',
  level: 'Stabilă',
  threshold: '3.850 €',
  commission: '45%',
  description: 'Performanță corectă, în linie cu standardele agenției.',
  color: 'green',
  bgColor: 'from-green-50 to-green-100',
  borderColor: 'border-green-300',
  textColor: 'text-green-700',
  icon: CheckCircleIcon
}, {
  zone: 'Zona Verde 2',
  emoji: '🟢',
  level: 'Ridicată',
  threshold: '4.900 €',
  commission: '50%',
  description: 'Activitate constantă, eligibil pentru bonusuri suplimentare.',
  color: 'green',
  bgColor: 'from-green-100 to-green-200',
  borderColor: 'border-green-400',
  textColor: 'text-green-800',
  icon: CheckCircleIcon
}, {
  zone: 'Zona Verde 3',
  emoji: '🟢',
  level: 'Excelentă',
  threshold: '7.250 €',
  commission: '55%',
  description: 'Top Performers – bonusuri extra și recunoaștere publică.',
  color: 'green',
  bgColor: 'from-green-200 to-green-300',
  borderColor: 'border-green-500',
  textColor: 'text-green-900',
  icon: StarIcon
}];
export function PerformanceGrid() {
  return <div className="space-y-8" data-id="element-2065">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-gradient-to-r from-[#357BEB] to-[#2868d8] text-white p-6 rounded-2xl text-center" data-id="element-2066">
        <h3 className="text-2xl font-bold mb-2" data-id="element-2067">
          📊 Grila oficială a Scării Performanței
        </h3>
        <p className="text-gray-100" data-id="element-2068">
          Cu cât totalul lunar este mai mare, cu atât procentul tău crește
        </p>
      </motion.div>
      <div className="space-y-4" data-id="element-2069">
        {performanceZones.map((zone, index) => {
        const Icon = zone.icon;
        return <motion.div key={zone.zone} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-gradient-to-r ${zone.bgColor} border-2 ${zone.borderColor} rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all`} data-id="element-2070">
              <div className="flex items-start space-x-4" data-id="element-2071">
                <div className="flex-shrink-0" data-id="element-2072">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-3xl shadow-md" data-id="element-2073">
                    {zone.emoji}
                  </div>
                </div>
                <div className="flex-1" data-id="element-2074">
                  <div className="flex items-center justify-between mb-2" data-id="element-2075">
                    <h4 className={`text-xl font-bold ${zone.textColor}`} data-id="element-2076">
                      {zone.zone}
                    </h4>
                    <Icon className={`w-6 h-6 ${zone.textColor}`} data-id="element-2077" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3" data-id="element-2078">
                    <div data-id="element-2079">
                      <p className="text-xs font-medium text-gray-600 mb-1" data-id="element-2080">
                        Nivel performanță
                      </p>
                      <p className={`text-sm font-bold ${zone.textColor}`} data-id="element-2081">
                        {zone.level}
                      </p>
                    </div>
                    <div data-id="element-2082">
                      <p className="text-xs font-medium text-gray-600 mb-1" data-id="element-2083">
                        Comision total
                      </p>
                      <p className={`text-sm font-bold ${zone.textColor}`} data-id="element-2084">
                        {zone.threshold}
                      </p>
                    </div>
                    <div data-id="element-2085">
                      <p className="text-xs font-medium text-gray-600 mb-1" data-id="element-2086">
                        Comision Agent
                      </p>
                      <p className={`text-lg font-bold ${zone.textColor}`} data-id="element-2087">
                        {zone.commission}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-2088">{zone.description}</p>
                </div>
              </div>
            </motion.div>;
      })}
      </div>
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 rounded-2xl p-6" data-id="element-2089">
        <div className="flex items-start space-x-4" data-id="element-2090">
          <div className="flex-shrink-0 w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-2xl" data-id="element-2091">
            💡
          </div>
          <div data-id="element-2092">
            <h4 className="text-lg font-bold text-[#132C53] mb-2" data-id="element-2093">
              Cum se calculează zona ta
            </h4>
            <p className="text-gray-700" data-id="element-2094">
              La finalul fiecărei luni (data 1), agenția calculează suma totală
              a comisioanelor tale generate. În funcție de această sumă, ești
              plasat automat în zona corespunzătoare. Procentul zonei se aplică
              asupra
              <span className="font-bold" data-id="element-2095"> întregului total lunar</span>, nu
              doar asupra diferenței.
            </p>
          </div>
        </div>
      </motion.div>
    </div>;
}